let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5se79")).then(() => parcelRequire('hp0db'));